module.exports = __webpack_public_path__ + "img/features04-01.72a21c0.png";